import { useEffect, useState } from "react";

import {
  useAccountSettings,
  useAuth,
  useBalances,
  useGetWebHostEnvironment,
  useHasAccessClaim,
  useSearchList,
} from "../../hooks";
import { View } from "./View";
import { useNavigate } from "react-router-dom";
import { IStaffDepartment } from "../../interfaces-and-types";
import { userAccessPolicyConstants } from "../../constants";
import { webHostEnviroment } from "../../enums";

export const AppHeader = () => {
  const { active_tenant_id, setActiveTenantId, signOut, staff_departments } =
    useAuth();
  const navigate = useNavigate();

  const userIsOwner = useHasAccessClaim(userAccessPolicyConstants.owner);
  const userIsDeveloper = useHasAccessClaim(
    userAccessPolicyConstants.developer
  );

  const hasDeveloperAccess = userIsDeveloper || userIsOwner;

  const navigateToProfile = () => navigate("/settings");
  const navigateToChangePassword = () => navigate("/settings/change-password");
  const navigateToCreatePin = () => navigate("/settings/create-transfer-pin");
  const navigateToChangePin = () => navigate("/settings/change-transfer-pin");

  const { data: settings } = useAccountSettings();
  const [isCreateNewModalOpen, setCreateNewModalOpen] = useState(false);
  const openCreateNewModal = () => {
    setCreateNewModalOpen(true);
    setOpenBusinessesDropDown(false);
  };

  const closeAddBusinessModal = () => setCreateNewModalOpen(false);

  const {
    activeBalanceCurrency,
    setActiveBalanceCurrency,
    isLoadingBalances,
    balances,
    // refreshBalances,
  } = useBalances();

  const [filterBusinessesSearchTerm, setFilterBusinessesSearchTerm] = useState<
    string | null
  >(null);

  const [isOpenBusinessesDropDown, setOpenBusinessesDropDown] = useState(false);

  const webHostEnviroment = useGetWebHostEnvironment();
  const headerColorClassNameForHostEnv = `switchapp-${webHostEnviroment}`;

  return (
    <View
      headerColorClassNameForHostEnv={headerColorClassNameForHostEnv}
      isLoadingBalances={isLoadingBalances}
      balances={balances}
      setActiveBalanceCurrency={setActiveBalanceCurrency}
      activeBalanceCurrency={activeBalanceCurrency}
      signOut={signOut}
      filterBusinessesSearchTerm={filterBusinessesSearchTerm}
      setFilterBusinessesSearchTerm={setFilterBusinessesSearchTerm}
      navigateToProfile={navigateToProfile}
      navigateToChangePassword={navigateToChangePassword}
      navigateToCreatePin={navigateToCreatePin}
      navigateToChangePin={navigateToChangePin}
      isCreateNewModalOpen={isCreateNewModalOpen}
      openCreateNewModal={openCreateNewModal}
      closeAddBusinessModal={closeAddBusinessModal}
      isOpenBusinessesDropDown={isOpenBusinessesDropDown}
      setOpenBusinessesDropDown={setOpenBusinessesDropDown}
      // access control
      userHasDeveloperAccess={hasDeveloperAccess}
    />
  );
};
